import easydropdown from 'easydropdown';
import Dropzone from 'dropzone';

export const fireForms = () => {

  var $form = $('.js-submission-form'),
    $field = $('.js-field');

  function handleKeyUp(e) {
    var $input = $(e.currentTarget)
    var $label = $input.closest('.field').find('label').first()

    if ($input.val() === '' || $input.val() === null || !$input.val().length) {
      $label.removeClass('fly--active');
    }
    else {
      $label.addClass('fly--active');
    }
  }

  function moveLabel(e) {
    var $input = $(e.currentTarget),
      $label = $input.closest($field).find('label').first();

    $label.addClass('fly--focus');
  }

  function handleBlur(e) {
    var $input = $(e.currentTarget)
    var $label = $input.closest('.field').find('label').first()

    $label.removeClass('fly--focus')
    handleKeyUp(e)
  }

  $form.on('keyup change', '.field--fly input[type=text], .js-field input[type=tel], .field--fly input[type=email], .field--fly select, .field--fly textarea', handleKeyUp);
  $form.on('focus', '.js-field input[type=text], .js-field input[type=tel], .js-field input[type=email], .js-field select, .js-field textarea', moveLabel);
  $form.on('blur', '.field--fly input[type=text], .js-field input[type=tel], .field--fly input[type=email], .field--fly select, .field--fly textarea', handleBlur);
}

$(function() {

    if ($('select.dropdown.statedropdown').length) {
        const edd = easydropdown.all();
    }

    fireForms();

    $('#ContactUsForm_ContactUsForm').on('submit', function(e){
        e.preventDefault();

        var headerHeight = $('.site-header').outerHeight();
        var scrollTopDifference;

        function getHeaderHeight() {
            if ($(window).width() > 1023.9) {
                scrollTopDifference = 131;
            } else {
                scrollTopDifference = headerHeight;
            }
        }
        getHeaderHeight();

        var form = $(this);
        $.ajax({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST',
            dataType: 'Json',
            success: function(res) {
                if (res) {
                    $('.js-submission-form').fadeOut(300, function() {
                        $('.js-thank-you').fadeIn(300, function(){
                            $('html,body').animate({
                                scrollTop: $('.submit-form-wrapper').offset().top - scrollTopDifference
                            }, 'slow');
                        })
                    });
                    $('.form-header-wrapper').fadeOut(300);

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'form_submission',
                            form_type: form.attr('id'),
                        })
                    }
                } else {

                }
            },
            error: function() {
                console.log('fail');
                $('.js-submission-form').fadeOut(300, function() {
                    $('.js-error').fadeIn(300) });
                    $('.form-header-wrapper').fadeOut(300);
            }
        });
    });


  const $dropzone = $('#js-dropzone')

  if ($dropzone.length) {
    const $dropzoneForm = $dropzone.closest('form')

    const dzUpload = new Dropzone('#js-dropzone .dropzone__title', {
      url: $dropzoneForm.data('file-upload-url'),
      addRemoveLinks: true,
      acceptedFiles: 'image/*,application/pdf',
      previewsContainer: '#js-dropzone .dropzone-preview',
      previewTemplate: `
      <div class="dz-preview dz-file-preview">
        <div class="dz-details">
          <div class="dz-filename"><span data-dz-name></span></div>
        </div>
        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
        <div class="dz-error-message"><span data-dz-errormessage></span></div>
      </div>
      `
    })

    dzUpload.on('success', (dz, resp) => {
      if (dz.status === 'success') {
        $dropzoneForm.append(`<input type="hidden" class="dz-${dz.upload.uuid}" name="Attachments[]" value="${resp.data.file}">`)
      }
    })

    dzUpload.on('removedfile', (dz) => {
      $dropzoneForm.find(`input.dz-${dz.upload.uuid}`).remove()
    })
  }


  if ($('.file-uploader').length) {
    function getFileInfo() {
      var x = $('.js-field.file-uploader input[type=file]')[0];
      var txt = "";

      if ('files' in x) {
        if (x.files.length == 0) {
          txt = "";
        } else {
          for (var i = 0; i < x.files.length; i++) {
            var file = x.files[i];
            if ('name' in file) {
              txt += 'You uploaded: <span class="panel-color--blue">' + file.name + '</span>';
            }
          }
        }
      }
      document.getElementById("file-upload-content").innerHTML = txt;
    }

    getFileInfo()

    $('.js-field.file-uploader input[type=file]').on('change', function() {
      getFileInfo()
    });


    function getCoverLetter() {
      var x = $('.js-field.upload-coverletter input[type=file]')[0];
      var txt = "";

      if ('files' in x) {
        if (x.files.length == 0) {
          txt = "";
        } else {
          for (var i = 0; i < x.files.length; i++) {
            var file = x.files[i];
            if ('name' in file) {
              txt += 'You uploaded: <span class="panel-color--blue">' + file.name + '</span>';
            }
          }
        }
      }
      document.getElementById("file-upload-coverletter").innerHTML = txt;
    }

    getCoverLetter()

    $('.js-field.upload-coverletter input[type=file]').on('change', function() {
      getCoverLetter()
    });
  }

  function commentFormScroll() {
    var scrollTopDifference;

    function getHeaderHeight() {
        if ($(window).width() > 1023.9) {
            scrollTopDifference = 300;
        } else {
            scrollTopDifference = 150;
        }
    }
    getHeaderHeight();

    var urlHash = window.location.href.split("#")[1];
    if (urlHash &&  $('#' + urlHash).length )
          $('html,body').animate({
              scrollTop: $('#' + urlHash).offset().top - scrollTopDifference
          }, 'slow');
  }

  if($('.pagetype-blogpost').length) {
    commentFormScroll()
  }

});
